import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Element Plus UI组件库
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// 自定义样式（A系统风格）
import './styles/main.scss'

// 工具类
import './utils/auth'
import { setupInterceptors } from './utils/request'

const app = createApp(App)

// 注册Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

// 使用插件
app.use(store)
app.use(router)
app.use(ElementPlus)

// 设置请求拦截器
setupInterceptors(store, router)

// 全局配置
app.config.globalProperties.$ELEMENT = {
    size: 'default',
    zIndex: 3000
}

// 挂载应用
app.mount('#app')

console.log('🚀 Auth Portal Frontend Started!')
console.log('📍 Environment:', process.env.NODE_ENV)
console.log('🔗 API Base URL:', process.env.VUE_APP_API_BASE_URL) 